import React from 'react';
import PropTypes from 'prop-types';
import UploadImage from './UploadImage';
import { useConnect } from '@lore/query-connect';
import getUploadInfo from '../../evaluation-project-educator/Uploads/getUploadInfo';

ProjectImages.propTypes = {
  project: PropTypes.object.isRequired,
  limit: PropTypes.number
};

export default function ProjectImages(props) {
  const { project, limit = 4 } = props;

  const uploads = useConnect('upload.find', {
    where: {
      eager: {
        $where: {
          evaluationProjectEducator: {
            $where: {
              projectId: project.id
            }
          }
        }
      }
    },
    pagination: {
      page: 1,
      pageSize: limit,
      order: 'id asc'
    }
  });

  const _uploads = uploads.data.filter(function(upload) {
    const info = getUploadInfo(upload.data.name);
    return info.isImage;
  });

  if (_uploads.length > 0) {
    return (
      <div className="px-4 pb-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {_uploads.map(function(upload, index) {
            return (
              <UploadImage
                key={index}
                upload={upload}
              />
            );
          })}
        </div>
      </div>
    );
  }

  return null;
}
